import type React from 'react'

type Props = {
  className?: string
}

const IconExclamation: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.01465 1.40625C5.81738 1.40625 3.8252 2.57812 2.71191 4.45312C1.62793 6.35742 1.62793 8.67188 2.71191 10.5469C3.8252 12.4512 5.81738 13.5938 8.01465 13.5938C10.1826 13.5938 12.1748 12.4512 13.2881 10.5469C14.3721 8.67188 14.3721 6.35742 13.2881 4.45312C12.1748 2.57812 10.1826 1.40625 8.01465 1.40625ZM8.01465 15C5.31934 15 2.8584 13.5938 1.51074 11.25C0.163086 8.93555 0.163086 6.09375 1.51074 3.75C2.8584 1.43555 5.31934 0 8.01465 0C10.6807 0 13.1416 1.43555 14.4893 3.75C15.8369 6.09375 15.8369 8.93555 14.4893 11.25C13.1416 13.5938 10.6807 15 8.01465 15ZM8.01465 3.75C8.39551 3.75 8.71777 4.07227 8.71777 4.45312V7.73438C8.71777 8.14453 8.39551 8.4375 8.01465 8.4375C7.60449 8.4375 7.31152 8.14453 7.31152 7.73438V4.45312C7.31152 4.07227 7.60449 3.75 8.01465 3.75ZM8.95215 10.3125C8.95215 10.8398 8.5127 11.25 8.01465 11.25C7.4873 11.25 7.07715 10.8398 7.07715 10.3125C7.07715 9.81445 7.4873 9.375 8.01465 9.375C8.5127 9.375 8.95215 9.81445 8.95215 10.3125Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconExclamation
